import * as actions from 'actions';
import * as Modules from 'components/modules';
import * as MediaQueries from 'components/modules/MediaQueries';
import T from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import * as selectors from 'selectors';
import { backgroundImageType } from 'types';
import styles from './sliderDesktopSection.css';
import * as s from './styled';
import VideoElement from './VideoElement';

class SliderDesktopSection extends React.Component {
  state = {
    index: 0,
    intoView: false,
  };

  componentWillReceiveProps(nextProps) {
    const prevIntoView = this.props.scrollPosition === this.props.scrollIndex;
    const nextIntoView = nextProps.scrollPosition === this.props.scrollIndex;
    if (prevIntoView === nextIntoView) {
      return;
    }

    if (nextIntoView) {
      this.setState({ intoView: true });
    } else {
      this.setState(
        () => ({ intoView: false }),
        () => {
          if (this.props.active) {
            this.clickHandler();
          }
        },
      );
    }
  }

  shouldComponentUpdate(nextProps) {
    const { scrollPosition } = nextProps;
    const { scrollIndex } = this.props;
    if (
      scrollPosition !== scrollIndex - 1 &&
      scrollPosition !== scrollIndex &&
      scrollPosition !== scrollIndex + 1
    ) {
      return false;
    }
    return true;
  }
  getIndex = index => Math.abs(index + 3) % this.props.data.length;

  onVideoElementClick = (e) => {
    e.stopPropagation();
  };

  indexCb = index =>
    this.setState(() => ({
      index: this.getIndex(index),
    }));

  clickHandler = () => {
    const { active, setSliderActive, setSliderInactive } = this.props;
    active ? setSliderInactive() : setSliderActive();
  };

  render() {
    const {
      title,
      subtitle,
      description,
      colors,
      reversed,
      height,
      active,
      data,
      textAlign,
      textHorizAlign,
      backgroundImage: {
        mobile: backgroundImageMobile,
        desktop: backgroundImageDesktop,
      },
    } = this.props;

    const { index, intoView } = this.state;
    const reversedNumber = +reversed;
    const isBackgroundImagePresent = !!(
      backgroundImageMobile.src || backgroundImageDesktop.src
    );

    return (
      <s.Section
        active={active}
        activeBackgroundColor={colors.activeBackground}
        backgroundColor={colors.background}
        reversed={reversedNumber}
        height={height}
      >
        {isBackgroundImagePresent && (
          <s.BackgroundOverlay
            backgroundColor={colors.background}
            backgroundImageDesktop={backgroundImageDesktop}
            backgroundImageMobile={backgroundImageMobile}
          />
        )}
        {data && (
          <s.SliderWrapper active={active}>
            <MediaQueries.Md>
              <div>
                <s.Overlay active={active} onClick={this.clickHandler} />
                <Modules.Dots
                  className={styles.dots}
                  quantity={data.length}
                  color={active ? colors.dotsActive : colors.dots}
                  activeIndex={index}
                />
                <Modules.StackCarousel
                  active={active}
                  className={active ? styles.sliderSpan : styles.slider}
                  overlayColor={colors.activeBackground}
                  dataArray={data}
                  Card={(props) => {
                    if (props.type === 'video') {
                      return (
                        <div className={styles.stackCarouselCardWrapper}>
                          {/* great-todo: make video available as a slide */}
                          <VideoElement
                            poster={props.poster}
                            src={props.src}
                            // src="/videos/aukcyon.mp4"
                            className={styles.stackCarouselVideo}
                          />
                        </div>
                      );
                    } else if (props.type === 'image') {
                      return (
                        <div className={styles.stackCarouselCardWrapper}>
                          <img
                            src={props.poster}
                            alt={props.alt}
                            className={styles.stackCarouselImg}
                          />
                        </div>
                      );
                    }
                    return null;
                  }}
                  indexCb={this.indexCb}
                  toggleSliderCb={this.clickHandler}
                  intoView={intoView}
                  topFrame={
                    <div className={styles.desktopFrameTop}>
                      <div className={styles.frameDots}>
                        <span className={styles.frameDot} />
                        <span className={styles.frameDot} />
                        <span className={styles.frameDot} />
                      </div>
                    </div>
                  }
                  bottomFrame={<div className={styles.desktopFrameBottom} />}
                />
              </div>
            </MediaQueries.Md>
            <MediaQueries.ToMd>
              <Modules.CardStack
                mode="sliderDesktop"
                overlayColor={colors.background}
                dataArray={data}
                Card={(props) => {
                  if (props.type === 'video') {
                    return (
                      <div
                        onClick={this.onVideoElementClick}
                        className={styles.cardStackCardWrapper}
                      >
                        <VideoElement
                          poster={props.poster}
                          src={props.src}
                          className={styles.cardStackSlideContent}
                        />
                      </div>
                    );
                  } else if (props.type === 'image') {
                    return (
                      <div className={styles.cardStackCardWrapper}>
                        <img
                          src={props.poster}
                          alt={props.alt}
                          className={styles.cardStackSlideContent}
                        />
                      </div>
                    );
                  }
                  return null;
                }}
              />
            </MediaQueries.ToMd>
          </s.SliderWrapper>
        )}
        <s.TextWrapper
          textAlign={textAlign}
          textHorizAlign={textHorizAlign}
          hidden={active}
          reversed={reversedNumber}
        >
          <s.TextContainer reversed={reversedNumber}>
            <Modules.TextBlock1
              title={title}
              subtitle={subtitle}
              description={description}
              colors={colors}
            />
          </s.TextContainer>
        </s.TextWrapper>
      </s.Section>
    );
  }
}

SliderDesktopSection.defaultProps = {
  height: null,
  img: null,
  scrollPosition: null,
  backgroundImage: {
    desktop: {
      src: false,
      backgroundRepeat: false,
      backgroundPosition: false,
      backgroundSize: false,
      backgroundOpacity: false,
    },
    mobile: {
      src: false,
      backgroundRepeat: false,
      backgroundPosition: false,
      backgroundSize: false,
      backgroundOpacity: false,
    },
  },
};
SliderDesktopSection.propTypes = {
  title: T.string.isRequired,
  subtitle: T.string.isRequired,
  description: T.arrayOf(T.string).isRequired,
  colors: T.shape({
    background: T.string,
    activeBackground: T.string,
    title: T.string,
    subtitle: T.string,
    description: T.string,
  }).isRequired,
  backgroundImage: T.shape({
    desktop: backgroundImageType,
    mobile: backgroundImageType,
  }),
  reversed: T.oneOfType([T.string, T.number]).isRequired,
  height: T.string,
  active: T.bool.isRequired,
  data: T.arrayOf(T.shape({ src: T.string, alt: T.string, poster: T.string }))
    .isRequired,
  scrollPosition: T.number,
  scrollIndex: T.number.isRequired,
  setSliderActive: T.func.isRequired,
  textAlign: T.string.isRequired,
  textHorizAlign: T.string.isRequired,
};

const mapDispatchToProps = (dispatch, props) => ({
  setSliderActive: () =>
    dispatch(actions.setActiveSection(`sliderDesktop-${props.code}`)),
  setSliderInactive: () => dispatch(actions.resetActiveSection()),
});

const mapStateToProps = (state, props) => ({
  active: selectors.isSliderDesktopActive(state, props),
  scrollPosition: selectors.getScrollPosition(state),
});
export default connect(mapStateToProps, mapDispatchToProps)(SliderDesktopSection);

/*
const mapDispatchToProps = (dispatch, props) => ({
  setSliderActive: () =>
    dispatch(actions.setActiveSection(`sliderDesktop-${props.title}`)),
});

const mapStateToProps = (state, props) => ({
  active: state.activeSection === `sliderDesktop-${props.title}`,
  scrollPosition: selectors.getScrollPosition(state),
});
export default connect(mapStateToProps, mapDispatchToProps)(SliderDesktopSection);

*/



// WEBPACK FOOTER //
// ./src/components/modules/SliderDesktopSection/SliderDesktopSection.js